import classcat from "classcat";
import React from "react";

import { IconArrowLeft } from "@touchtech/web-baselayer-ui";

import css from "./IFramePage.module.css";
import useManageIFramePage from "./hooks/useManageIFramePage";

const IFramePage = () => {
  const { handleClose, portalUrl, t } = useManageIFramePage();

  return (
    <div className={css.container}>
      <button
        className={classcat(["text-headline-3xl", css.backContainer])}
        onClick={handleClose}
      >
        <IconArrowLeft />
      </button>
      {portalUrl && (
        <iframe
          title={t("Staff Portal page")}
          className={css.iframe}
          src={portalUrl}
          allowFullScreen
        />
      )}
    </div>
  );
};

export default IFramePage;
